// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "audio[data-v-9d37aa34]::-webkit-media-controls-panel{background-color:#fff}.hui-audio-title[data-v-9d37aa34]{display:flex;flex-direction:row;align-items:center;justify-content:space-between;border:1px solid #eee;margin:10px 0 10px 0}.hui-audio-waveview[data-v-9d37aa34]{width:100%;height:60px;border:1px solid #eee}", ""]);
// Exports
module.exports = exports;
